import React, { Component } from 'react';
//import logo from './logo.svg';
//import './App.css';
import './css/styles.css';
import './css/media.css';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './components/Home'
import Reset from './components/Reset'
import ContentPage from './components/ContentPage'
import {info} from './info.js'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentWillMount() {
    const links = [
      { name:'Home',path:'/',exact:true, },
    ]
    this.setState({links:links})
  }
  render() {
    return (
      <Router>
        <React.Fragment>
          <Navbar
            name={info.name}
            className="navbar-dark bg-dark"
            links={this.state.links}
          />
          <main>
            <Route exact path="/" component={Home} />
            <Route exact path="/:type/id/:id" component={ContentPage} />
            <Route exact path="/:type/:slug" component={ContentPage} />
            <Route exact path="/reset" component={Reset} />
          </main>
        </React.Fragment>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js